export class ToastMessage {
	public readonly element = document.createElement("li");
	private readonly messageEl = document.createElement("div");

	constructor(message: string|Node, private timeToLive: number = 3000) {
		this.element.classList.add("toast_item");
		this.element.setAttribute("aria-live", "assertive");
		this.element.setAttribute("role", "status");
		this.messageEl.classList.add("toast_message");
		this.element.appendChild(this.messageEl);
		if (! (message instanceof Node)) {
			message = document.createTextNode(message);
		}
		this.messageEl.appendChild(message);
	}

	public addIcon(icon: HTMLElement, prepend: boolean = true): void {
		const container = document.createElement("div");
		container.classList.add("toast_icon");
		container.appendChild(icon);

		if (prepend) {
			this.element.insertBefore(container, this.messageEl);
		} else {
			this.element.appendChild(container);
		}
	}

	public removeOnDelay(): Promise<void> {
		return new Promise(resolve => {
			setTimeout(() => {
				this.element.classList.add("-removing");
			}, this.timeToLive);
			setTimeout(() => {
				if (this.element.parentNode) {
					this.element.parentNode.removeChild(this.element);
				}
				this.element.classList.remove("-removing");
				resolve();
			}, this.timeToLive + 310);
		});
	}

	public static make(message: string|Node, options: { iconClass?: string; timeToLive?: number } = { }): ToastMessage {
		const out = new ToastMessage(message, options.timeToLive);
		if (options.iconClass) {
			const icon = document.createElement("i");
			icon.className = options.iconClass;
			out.addIcon(icon, true);
		}
		return out;
	}
}

export class InlineToastMessage {

	public readonly element = document.createElement("div");
	public readonly message = document.createElement("div");

	constructor(ref: HTMLElement, content: string|Node) {
		this.message.classList.add("toast_item", "-inline");
		this.message.setAttribute("aria-live", "assertive");
		this.message.setAttribute("role", "status");
		this.message.append(content);
		this.message.tabIndex = 0;

		this.element.classList.add("toast_container");
		this.element.style.height = (ref.getBoundingClientRect().height) + "px";
		this.element.append(this.message);

		if (!ref.parentNode) {
			throw new Error("No parent node");
		}

		ref.parentNode.insertBefore(this.element, ref.nextSibling);
		this.message.focus();
		this.element.addEventListener("focusout", () => {
			this.message.tabIndex = -1;
			this.message.classList.add("-removing");
			setTimeout(() => {
				if (this.element.parentNode) {
					this.element.parentNode.removeChild(this.element);
				}
			}, 300);
		});
	}
}

export class ToastMessageContainer {

	public readonly element: HTMLElement = document.createElement("div");
	private readonly ul: HTMLElement = document.createElement("ul");

	constructor(floating: boolean = true) {
		this.element.classList.add("toast");
		this.ul.classList.add("toast_itemList");
		if (floating) {
			this.element.classList.add("-floating");
		}
		this.element.appendChild(this.ul);
	}

	add(message: ToastMessage): Promise<void> {
		message.element.classList.remove("-removing");
		message.element.classList.add("-adding");
		if (this.ul.firstChild) {
			this.ul.insertBefore(message.element, this.ul.firstChild);
		} else {
			this.ul.appendChild(message.element);
		}
		setTimeout(() => message.element.classList.remove("-adding"), 10);
		return message.removeOnDelay();
	}
}
